// File: noviopus-ats-client/src/features/PageLayout/pageLayoutSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PageLayoutState } from './types';

export const initialState: PageLayoutState = {
  params: {},
  dialogs: [],
  dialogParams: [],
  isReactivateButtonDisabled: false,
};

const pageLayoutSlice = createSlice({
  name: 'pageLayout',
  initialState,
  reducers: {
    setCurrentPageParams: (state, action: PayloadAction<any>) => {
      state.params = action.payload || {};
    },
    setCurrentPageDialog: (state, action: PayloadAction<{ dialog: string; params?: any }>) => {
      state.dialogs.push(action.payload.dialog);
      state.dialogParams.push(action.payload.params || {});
    },
    removeCurrentPageDialog: (state, action: PayloadAction<string | undefined>) => {
      if (action.payload) {
        const index = state.dialogs.findIndex(d => d === action.payload);
        if (index !== -1) {
          state.dialogs.splice(index, 1);
          state.dialogParams.splice(index, 1);
        }
      } else {
        // Remove last if no ID provided (pop behavior)
        state.dialogs.pop();
        state.dialogParams.pop();
      }
    },
    clearDialogs: (state) => {
      state.dialogs = [];
      state.dialogParams = [];
    },
    disableReactivateButton: (state) => {
      state.isReactivateButtonDisabled = true;
    },
    enableReactivateButton: (state) => {
      state.isReactivateButtonDisabled = false;
    },
  },
});

export const {
  setCurrentPageParams,
  setCurrentPageDialog,
  removeCurrentPageDialog,
  clearDialogs,
  disableReactivateButton,
  enableReactivateButton
} = pageLayoutSlice.actions;

export default pageLayoutSlice.reducer;